import Environment from '../models/Environment.model'
import EnvironmentsConfig from '../config/Environments.config'

export default {
  environment: (state, getters, rootState) => {
    if (!rootState.auth.server) {
      return
    } else if (!EnvironmentsConfig.hasOwnProperty(rootState.auth.server)) {
      throw new Error(`Invalid environment '${rootState.auth.server}'`)
    }

    return new Environment(EnvironmentsConfig[rootState.auth.server])
  }
}
